const store = {
    namespaced: true,
    state() {
        return {
            sellers: [
                {
                    name: 'Anatolii Pupkin',
                    id: 17,
                },
                {
                    name: 'Sasa Businessman',
                    id: 137,
                },
            ],
        }
    },
    getters: {
        sellers: (state) => state.sellers,
    },
    mutations: {
        SET_SELLERS: (state, data) => state.sellers = data,
    },
    actions: {
        fetchSellers: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'GET',
                    url: `/base/store_sellers`,
                })
                if (res.data.length) commit('SET_SELLERS', res.data)
            } catch (error) {
                console.dir(error)
            }
        },
    }
}

export default store